import { render } from "./UserPermission.vue?vue&type=template&id=0142c0ca&scoped=true&ts=true"
import script from "./UserPermission.vue?vue&type=script&lang=ts"
export * from "./UserPermission.vue?vue&type=script&lang=ts"

import "./UserPermission.vue?vue&type=style&index=0&id=0142c0ca&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0142c0ca"]])

export default __exports__